import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  authModal: boolean;
  loginModal: boolean;
  memberListing: boolean;
  passwordModal: boolean;
  registerModal: boolean;
};

type modalSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const updateAuthModal: modalSliceReducer<boolean> = (state, action) => {
  state.authModal = action.payload;
};
const updateLoginModal: modalSliceReducer<boolean> = (state, action) => {
  state.loginModal = action.payload;
};
const updateMemberListing: modalSliceReducer<boolean> = (state, action) => {
  state.memberListing = action.payload;
};
const updateRegisterModal: modalSliceReducer<boolean> = (state, action) => {
  state.registerModal = action.payload;
};
const updatePasswordModal: modalSliceReducer<boolean> = (state, action) => {
  state.passwordModal = action.payload;
};

const initialState: initialType = {
  authModal: false,
  loginModal: false,
  memberListing: false,
  passwordModal: false,
  registerModal: false,
};

const modalSlice = createSlice({
  initialState,
  name: "modal",
  reducers: {
    updateAuthModal,
    updateLoginModal,
    updateMemberListing,
    updatePasswordModal,
    updateRegisterModal,
  },
});

export default modalSlice;
